<template>
  <div>
    <ca-row>
      <ca-col size="2">
        <ca-button full-width @click="onEdit(workShift.id)">Editar</ca-button>
      </ca-col>
      <ca-col size="2">
        <ca-button full-width @click="onDelete(workShift.id)">Excluir</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getWorkShift"
            :on-fetch-success="setWorkShift">
            <div v-if="workShift">
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Código">
                    {{ workShift.code }}
                  </ca-field>
                </ca-col>
                <ca-col size="4">
                  <ca-field label="Permitido flexibilidade dos horários">
                    {{ workShift.flexibleHours ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Jornada de trabalho">
                    {{ workload }}
                  </ca-field>
                </ca-col>
                <ca-col size="4">
                  <ca-field label="Tipo de intervalo">
                    {{ workShift.breakType.description }}
                  </ca-field>
                </ca-col>
                <ca-col size="4">
                  <ca-field label="Intervalo">
                    {{ getIntervalFromWorkShift(workShift) }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Compartilhado">
                    {{ workShift.shared ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import { getWorkShift, getIntervalFromWorkShift, deleteWorkShift } from './workShiftService';

export default {
  name: 'WorkShiftsPage',
  data() {
    return {
      workShift: null,
    };
  },
  computed: {
    workload() {
      return `${this.workShift.checkInTime} a ${this.workShift.checkOutTime}`;
    },
  },
  methods: {
    getIntervalFromWorkShift,
    getWorkShift() {
      return getWorkShift(this.$route.params.id);
    },
    setWorkShift(workShift) {
      this.workShift = workShift;
    },
    onEdit(id) {
      this.$router.push({ name: 'EditWorkShift', params: { id } });
    },
    onDelete(id) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteWorkShift(id)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$router.back();
            })
            .catch(e => {
              this.$toaster[e.status](e.message);
            });
        },
      });
    },
  },
};
</script>
